export function buildPageRows(groupIndexStart, taskIndexStart, rowsPerPage, taskGroups) {
  let currentGroupIndex = groupIndexStart;
  let currentTaskIndex = taskIndexStart;
  const pageRows = [];
  // Put a page header at the beginning of each page.
  let pageHeader = taskGroups[groupIndexStart].label;
  if (taskIndexStart !== 0) {
    pageHeader += '(cont.)';
  }
  pageRows.push({
    type: 'TASK_GROUP_HEADER',
    label: pageHeader
  });
  while (pageRows.length < rowsPerPage) {
    const currentGroup = taskGroups[currentGroupIndex];
    const currentTaskId = currentGroup.taskIds[currentTaskIndex];
    if (currentGroup && currentTaskId) {
      pageRows.push({
        type: 'TASK',
        taskId: currentTaskId,
      });
      currentTaskIndex += 1;
    }
    // Check if you pushed the last task
    if (currentTaskIndex === currentGroup.taskIds.length) {
      // Reset task index and increment group index
      currentTaskIndex = 0;
      currentGroupIndex += 1;
      // Don't start a new header close to the bottom of a page.
      if (pageRows.length < rowsPerPage - 1 && taskGroups[currentGroupIndex]) {
        // Push the header
        pageRows.push({
          type: 'TASK_GROUP_HEADER',
          label: taskGroups[currentGroupIndex].label
        });
      } else {
        // Don't start a new section so close to the bottom.
        return { pageRows, endGroupIndex: currentGroupIndex, endTaskIndex: currentTaskIndex };
      }
    }
  }
  return { pageRows, endGroupIndex: currentGroupIndex, endTaskIndex: currentTaskIndex };
}

export function buildPages(taskGroups) {
  if (taskGroups.length < 1) return [];

  let currentGroupIndex = 0;
  let currentTaskIndex = 0;
  const pages = [];

  while (currentGroupIndex < taskGroups.length) {
    // Take one row off the first page to make room for the header.
    const rowsPerPage = pages.length === 0 ? 10 : 11;
    const { pageRows, endGroupIndex, endTaskIndex } = buildPageRows(currentGroupIndex, currentTaskIndex, rowsPerPage, taskGroups);
    pages.push(pageRows);
    currentGroupIndex = endGroupIndex;
    currentTaskIndex = endTaskIndex;
  }
  return pages;
}



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/PrintChecklist/PrintChecklistTaskList/helpers.js